import { render, staticRenderFns } from "./CommonMenu.vue?vue&type=template&id=0213c27a"
import script from "./CommonMenu.vue?vue&type=script&lang=js"
export * from "./CommonMenu.vue?vue&type=script&lang=js"
import style0 from "./CommonMenu.vue?vue&type=style&index=0&id=0213c27a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports